import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CustomSelect from '@/views/components/CustomSelect/CustomSelect';

import api from '@/services/api';

const AddLetterDeptAutoSuggest = ({ label, setValueExt, propValue, defaultValue=null, disabled=false }) => {

	const [ value, setValue ] = useState();
	const [ suggestions, setSuggestions ] = useState([]);
	const [ selectedDepartment, setSelectedDepartment ] = useState();

	useEffect(() => {
		if (propValue) {
			setSelectedDepartment(propValue.id);
			setValue({value: propValue.id, name: propValue.name});
		}
	}, [ propValue ]);

	useEffect(() => {
		if (selectedDepartment) {
			setValueExt("department.id", selectedDepartment);
		}
	}, [ selectedDepartment, setValueExt ]);

	useEffect(() => {
		api.get(`/autocomplete/departments?q=`)
			.then(response => {
				setSuggestions(getSuggestions(response.data));
				if(defaultValue && typeof defaultValue === 'number') {
					const findDepartment = response?.data?.find((department) => department.id === defaultValue);
					if(findDepartment) {
						setValue({ value: findDepartment.id, label: findDepartment.name });
					}
				}
			});
	}, []);

	useEffect(() => {
		const found = suggestions.find((val) => { return val.value == selectedDepartment; });

		if (found) {
			setValue(found);
		}
	}, [ suggestions, selectedDepartment ]);

	const getSuggestions = (array) => {
		return array.map((item) => {
			return { value: item.id, label: item.name };
		});
	};

	const handleChangeDept = (item) => {
		setValue(item);
		if(item){
			setValueExt("department.id", item.value);
		} else {
			setValueExt("department.id", null);
		}
	};

	return (
		<CustomSelect
			isClearable={ true }
			defaultValue={ defaultValue }
			label={ label }
			placeholder=""
			value={ value }
			options={ suggestions }
			formInput={ true }
			onChange={ handleChangeDept }
			disabled={ disabled }
		/>
	);
};

AddLetterDeptAutoSuggest.propTypes = {
	label: PropTypes.string,
	setValueExt: PropTypes.func,
	propValue: PropTypes.any,
	disabled: PropTypes.bool,
};

export default AddLetterDeptAutoSuggest;
